import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CARD_ELEMENT_TYPE } from '../../../../../../../services/cards/constants';
import CardPhotoElementConfiguration from '../CardPhotoElementConfiguration';
import CardRectangleElementConfiguration from '../CardRectangleElementConfiguration';
import CardElementConfiguration from '../CardElementConfiguration';
import useAssetImageUpoad from '../../../../../../../hooks/useAssetImageUpload';
import ImageUpload from '../../../../../../../components/global/ImageUpload';

const propTypes = {
  className: PropTypes.string,
  cardTemplate: PropTypes.shape({
    id: PropTypes.string.isRequired,
    card_elements: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  getElementConfigurationStateById: PropTypes.func.isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
  onCardTemplateChange: PropTypes.func.isRequired,
};

const CardTemplateSettings = ({
  className,
  cardTemplate,
  getElementConfigurationStateById,
  onElementConfigurationChange,
  onCardTemplateChange,
}) => {
  const classes = classNames({
    'card-template-settings-row': true,
    [className]: !!className,
  });

  const { uploading, onUpload, onUploadReset, image } = useAssetImageUpoad({
    onImageUploaded: assetImage => {
      onCardTemplateChange({
        id: cardTemplate.id,
        asset_image_id: assetImage.id,
      });
    },
  });

  return (
    <div className={classes}>
      <h6>{cardTemplate.name}</h6>
      <div className="card-template-settings-row-elements">
        <ImageUpload
          id={`${cardTemplate.id}-image-upload`}
          loading={uploading}
          onImageDismiss={() => {
            onUploadReset();
            onCardTemplateChange({ id: cardTemplate.id, asset_image_id: null });
          }}
          onInputChange={event => {
            const [file] = event.target.files;
            onUpload(file);
          }}
          image={image}
          className="card-element-configuration"
        />

        {cardTemplate.card_elements.map(cardElement => {
          if (
            !getElementConfigurationStateById({
              elementId: cardElement.id,
              cardTemplateId: cardTemplate.id,
            })
          ) {
            return null;
          }

          if (cardElement.type === CARD_ELEMENT_TYPE.PHOTO) {
            return (
              <CardPhotoElementConfiguration
                key={cardElement.id}
                element={cardElement}
                elementConfiguration={getElementConfigurationStateById({
                  elementId: cardElement.id,
                  cardTemplateId: cardTemplate.id,
                })}
                onChange={config =>
                  onElementConfigurationChange({
                    elementId: cardElement.id,
                    cardTemplateId: cardTemplate.id,
                    config,
                  })
                }
              />
            );
          }

          if (cardElement.type === CARD_ELEMENT_TYPE.RECTANGLE) {
            return (
              <CardRectangleElementConfiguration
                key={cardElement.id}
                elementConfiguration={getElementConfigurationStateById({
                  elementId: cardElement.id,
                  cardTemplateId: cardTemplate.id,
                })}
                onChange={config =>
                  onElementConfigurationChange({
                    elementId: cardElement.id,
                    cardTemplateId: cardTemplate.id,
                    config,
                  })
                }
              />
            );
          }

          return (
            <CardElementConfiguration
              key={cardElement.id}
              element={cardElement}
            />
          );
        })}
      </div>
    </div>
  );
};

CardTemplateSettings.propTypes = propTypes;

export default CardTemplateSettings;
